(() => {
  const TAG = "countdown-timer";

  class CountdownTimer30 extends HTMLElement {
    connectedCallback() {
      const DURATION_MS = 30 * 60 * 1000;
      const RED_AT_MS = 5 * 60 * 1000;
      const SHAKE_AT_MS = 60 * 1000;

      if (!document.getElementById("cd-30min-styles")) {
        const style = document.createElement("style");
        style.id = "cd-30min-styles";
        style.textContent = `
          countdown-timer.cd-red .countdown-number,
          countdown-timer.cd-red .countdown-label {
            color: #d10000 !important;
          }
          @keyframes cdShake {
            0%, 100% { transform: translateX(0); }
            10% { transform: translateX(-2px); }
            20% { transform: translateX(2px); }
            30% { transform: translateX(-3px); }
            40% { transform: translateX(3px); }
            50% { transform: translateX(-2px); }
            60% { transform: translateX(2px); }
            70% { transform: translateX(-1px); }
            80% { transform: translateX(1px); }
            90% { transform: translateX(-1px); }
          }
          countdown-timer.cd-shake .countdown-timer {
            animation: cdShake 0.45s infinite;
          }
        `;
        document.head.appendChild(style);
      }

      const daysEl = this.querySelector("[data-days]");
      const hoursEl = this.querySelector("[data-hours]");
      const minutesEl = this.querySelector("[data-minutes]");
      const secondsEl = this.querySelector("[data-seconds]");

      const pad = (n) => String(n).padStart(2, "0");

      const deadline = Date.now() + DURATION_MS;

      const update = () => {
        const now = Date.now();
        const msLeft = deadline - now;

        if (msLeft <= 0) {
          this.classList.remove("cd-red", "cd-shake");
          clearInterval(this._interval);
          return;
        }

        if (msLeft <= RED_AT_MS) this.classList.add("cd-red");
        else this.classList.remove("cd-red");

        if (msLeft <= SHAKE_AT_MS) this.classList.add("cd-shake");
        else this.classList.remove("cd-shake");

        const totalSeconds = Math.floor(msLeft / 1000);

        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        if (daysEl) daysEl.textContent = pad(days);
        if (hoursEl) hoursEl.textContent = pad(hours);
        if (minutesEl) minutesEl.textContent = pad(minutes);
        if (secondsEl) secondsEl.textContent = pad(seconds);
      };

      update();
      this._interval = setInterval(update, 1000);
    }

    disconnectedCallback() {
      if (this._interval) clearInterval(this._interval);
    }
  }

  if (!customElements.get(TAG)) {
    customElements.define(TAG, CountdownTimer30);
  }
})();